"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var Card = function (_a) {
    var id = _a.id, src = _a.src, title = _a.title, text = _a.text, className = _a.className, children = _a.children, props = __rest(_a, ["id", "src", "title", "text", "className", "children"]);
    return (jsx_runtime_1.jsx("div", __assign({ className: "col-lg-4 col-md-6 p-1" }, { children: jsx_runtime_1.jsxs("div", __assign({ id: id, className: "border card " + className }, { children: [src && (jsx_runtime_1.jsx("img", __assign({ className: "p-3 card-img-top img-fluid m-auto", src: src, alt: "" + id }, props), void 0)),
                jsx_runtime_1.jsxs("div", __assign({ className: "card-body" }, { children: [title && (jsx_runtime_1.jsx("h2", __assign({ className: "text-center card-title text-capitalize" }, { children: title }), void 0)),
                        text && jsx_runtime_1.jsx("p", __assign({ className: "text-center card-text" }, { children: text }), void 0),
                        children && jsx_runtime_1.jsx("div", __assign({ className: "pt-4" }, { children: children }), void 0)] }), void 0)] }), void 0) }), void 0));
};
exports.Card = Card;
// Variants
exports.Card.Hover = styled_components_1.default(exports.Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover {\n    box-shadow: 1px 1px 5px 4px whitesmoke;\n  }\n"], ["\n  &:hover {\n    box-shadow: 1px 1px 5px 4px whitesmoke;\n  }\n"])));
exports.Card.BGImage = styled_components_1.default(exports.Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-image: url('", "');\n  background-size: cover;\n"], ["\n  background-image: url('", "');\n  background-size: cover;\n"])), function (props) { return props.imgURL || 'none'; });
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map